import { useState } from 'react';
import styled from 'styled-components';
import IntegrationCard from 'components/IntegrationsDashboard/IntegrationCard';
import { useIntegrations } from 'utils/integrations';
import { Button, Text, Title, Pagination } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

const StyledSectionTitle = styled(Title)`
  margin: 40px 0 15px 0;
  text-transform: capitalize;
`;

const StyledIntegrationsCardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-auto-rows: 1fr;
  gap: 15px 15px;
`;

const StyledPaginationWrapper = styled.div`
  margin-top: 15px;
`;

const Overview = () => {
  const { data, loading, error } = useIntegrations();
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(1);
  const apiPerPage = 12;

  const displayApi =
    data?.Apis?.edges &&
    data.Apis.edges
      .slice((pageNumber - 1) * apiPerPage, pageNumber * apiPerPage)
      .map(({ node }) => {
        return (
          <IntegrationCard
            key={node?.id}
            id={node?.id}
            name={node?.name}
            type={node?.type}
            description={node.description}
            onEdit={id => navigate(`/api/edit/${id}`)}
          />
        );
      });

  const pageCount = Math.ceil(data?.Apis?.edges.length / apiPerPage);

  const handlePageChange = (page: number) => {
    setPageNumber(page);
  };

  return (
    <>
      <Button color="dark" variant="outline" onClick={() => navigate('/api/add')}>
        + Add API
      </Button>
      <StyledSectionTitle order={4}>LIST OF ALL APIs</StyledSectionTitle>
      {loading || error ? (
        <Text style={{ margin: '50px 0px' }}>
          {loading ? 'Loading...' : 'Failed to load the APIs.'}
        </Text>
      ) : null}
      <StyledIntegrationsCardsWrapper>{displayApi}</StyledIntegrationsCardsWrapper>
      <StyledPaginationWrapper>
        <Pagination
          page={pageNumber}
          total={pageCount}
          position={'center'}
          onChange={handlePageChange}
          radius={'xs'}
        />
      </StyledPaginationWrapper>
    </>
  );
};

export default Overview;
